var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgGrid = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66666 2.99999C1.66666 2.26361 2.26361 1.66666 2.99999 1.66666H4.33332C5.0697 1.66666 5.66666 2.26361 5.66666 2.99999V4.33332C5.66666 5.0697 5.0697 5.66666 4.33332 5.66666H2.99999C2.26361 5.66666 1.66666 5.0697 1.66666 4.33332V2.99999Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33332 2.99999C8.33332 2.26361 8.93028 1.66666 9.66666 1.66666H11C11.7364 1.66666 12.3333 2.26361 12.3333 2.99999V4.33332C12.3333 5.0697 11.7364 5.66666 11 5.66666H9.66666C8.93028 5.66666 8.33332 5.0697 8.33332 4.33332V2.99999Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66666 9.66666C1.66666 8.93028 2.26361 8.33332 2.99999 8.33332H4.33332C5.0697 8.33332 5.66666 8.93028 5.66666 9.66666V11C5.66666 11.7364 5.0697 12.3333 4.33332 12.3333H2.99999C2.26361 12.3333 1.66666 11.7364 1.66666 11V9.66666Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33332 9.66666C8.33332 8.93028 8.93028 8.33332 9.66666 8.33332H11C11.7364 8.33332 12.3333 8.93028 12.3333 9.66666V11C12.3333 11.7364 11.7364 12.3333 11 12.3333H9.66666C8.93028 12.3333 8.33332 11.7364 8.33332 11V9.66666Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgGrid, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/grid.8c83632a.svg";
export { ForwardRef as ReactComponent };